import { render } from "./protocol_request.vue?vue&type=template&id=1cf1fc9f&scoped=true"
import script from "./protocol_request.vue?vue&type=script&lang=js"
export * from "./protocol_request.vue?vue&type=script&lang=js"

import "./protocol_request.vue?vue&type=style&index=0&id=1cf1fc9f&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf1fc9f"],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_request.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf1fc9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf1fc9f', __exports__)) {
    console.log('reload')
    api.reload('1cf1fc9f', __exports__)
  }
  
  module.hot.accept("./protocol_request.vue?vue&type=template&id=1cf1fc9f&scoped=true", () => {
    console.log('re-render')
    api.rerender('1cf1fc9f', render)
  })

}


export default __exports__